import React from 'react';
import { Box, TextField, InputAdornment } from '@mui/material';
import { FaSearch } from 'react-icons/fa';
import GoalStatusFilter from '../../common/filters/GoalStatusFilter';

const MyIDPFilters = ({
  searchInputValue,
  setSearchInputValue,
  selectedStatuses,
  setSelectedStatuses,
  goalStatuses,
}) => {
  return (
    <Box sx={{
      display: 'flex',
      gap: '16px',
      flexWrap: 'wrap',
      width: '100%',
      alignItems: 'flex-start'
    }}>
      <TextField
        placeholder="Search development plans..."
        variant="outlined"
        size="small"
        value={searchInputValue}
        onChange={(e) => setSearchInputValue(e.target.value)}
        autoComplete="off"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <FaSearch style={{ color: '#6B7280' }} />
            </InputAdornment>
          ),
        }}
        sx={{
          flex: 1,
          maxWidth: '400px',
          minWidth: '200px',
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            height: '40px',
            fontSize: '14px',
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#2563eb',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#2563eb',
            }
          },
        }}
      />

      <GoalStatusFilter
        selectedStatuses={selectedStatuses}
        onStatusChange={setSelectedStatuses}
        statuses={goalStatuses}
        label="Filter by Status"
        width={250}
      />
    </Box>
  );
};

export default MyIDPFilters;
